import { useState } from 'react';
import { api } from '../api.js';

export default function ReportButton({ type, refId, label = '' }) {
  const [open, setOpen]     = useState(false);
  const [reason, setReason] = useState('');
  const [detail, setDetail] = useState('');
  const [saving, setSaving] = useState(false);
  const [done, setDone]     = useState(false);

  const submit = async () => {
    if (!reason.trim()) return;
    setSaving(true);
    try {
      await api.submitReport({ type, ref_id: refId, reason: reason.trim(), detail: detail.trim() || undefined });
      setDone(true);
      setTimeout(() => { setOpen(false); setDone(false); setReason(''); setDetail(''); }, 1500);
    } catch (e) {
      alert(e.message);
    } finally { setSaving(false); }
  };

  return (
    <>
      <button onClick={() => setOpen(true)}
        className="text-xs text-gray-400 hover:text-coral-500 transition-colors"
        title="Inhalt melden" aria-label="Inhalt melden">
        <span aria-hidden="true">⚑</span> Melden
      </button>

      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
          <div className="card max-w-sm w-full space-y-3">
            <h2 className="font-bold text-gray-900 text-sm">Inhalt melden</h2>
            {label && <p className="text-xs text-gray-500 bg-gray-50 rounded p-2">{label}</p>}

            {done ? (
              <p className="text-sm text-teal-700 text-center py-2">🫧 Danke — die Meldung wurde übermittelt.</p>
            ) : (
              <>
                <div>
                  <label className="label">Grund *</label>
                  <select className="input text-sm" value={reason} onChange={(e) => setReason(e.target.value)}>
                    <option value="">Bitte wählen…</option>
                    <option value="Falsche Antwort">Falsche Antwort</option>
                    <option value="Unklare Fragestellung">Unklare Fragestellung</option>
                    <option value="Veralteter Inhalt">Veralteter Inhalt</option>
                    <option value="Tippfehler">Tippfehler / Rechtschreibfehler</option>
                    <option value="Fehlendes Bild">Fehlendes Bild / Medium</option>
                    <option value="Sonstiges">Sonstiges</option>
                  </select>
                </div>
                <div>
                  <label className="label">Details (optional)</label>
                  <textarea className="input text-sm" rows={3} value={detail}
                    onChange={(e) => setDetail(e.target.value)}
                    placeholder="Was genau ist falsch oder unklar?" />
                </div>
                <div className="flex gap-2 justify-end">
                  <button onClick={() => setOpen(false)} className="btn-secondary text-xs">Abbrechen</button>
                  <button onClick={submit} disabled={saving || !reason}
                    className="btn-primary text-xs">
                    {saving ? 'Senden…' : 'Meldung absenden'}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
